import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CheckoutForm from './CheckoutForm';
import { Elements } from '@stripe/react-stripe-js';
import { useAuthContext } from '../../context/AuthContext';
import Loading from "../Hooks/Loading";
import { API } from '../../constant';
import { getToken } from '../../helpers';
import { stripePromise } from '../../stripePromise';

const StripeSubscription = () => {
const [plan, setPlan] = useState(null);
const [setupData, setSetupData] = useState(null); // { clientSecret, customerId }
const { user, isLoading } = useAuthContext();

useEffect(() => {
    const fetchPlan = async () => {
        try {
            const response = await axios.get(`${API}/plans/9`);
            setPlan(response.data.data.attributes);
        } catch (error) {
            console.error('Error fetching plan:', error);
        }
    };
    fetchPlan();
}, []);

useEffect(() => {
    if (!user || isLoading) return;

    const fetchSetupIntent = async () => {
        try {
            const response = await axios.post(`${API}/stripe/setup-intent`, {
                customerIds: user.customerId || null,
                customerName: user.username,
                customerEmail: user.email,
                customerAddress: {
                    line1: user.address || '',
                    city: user.city || '',
                    state: user.state || '',
                    postal_code: user.postalCode || '',
                    country: user.country || '',
                },
            }, {
                headers: { Authorization: `Bearer ${getToken()}` },
            });
            setSetupData(response.data);
        } catch (error) {
            console.error('Error creating setup intent:', error);
        }
    };

    fetchSetupIntent();
}, [user, isLoading]);

if (!plan || !setupData || isLoading) return <Loading />;

return (
<>
    <div className="premium-info-card">
        <div className="premium-top-row">
            <div className="premium-title-col">
                <div className="head-title">Go Premium</div>
                <p className="sub-title-text">Unlock full access with a simple monthly subscription.</p>
            </div>
            <div className="plan-details">
                <p className="heading">{plan.name}</p>
                <div className="plan-meta">
                    <p><span>Amount:</span> ${plan.amount}</p>
                    <p><span>Billing:</span> {plan.interval}</p>
                </div>
            </div>
        </div>
    </div>
    <div className="billing-form-card">
        <Elements stripe={stripePromise} options={{ fonts: [{ cssSrc: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap' }] }}>
            <CheckoutForm
                plan={plan}
                clientSecret={setupData.clientSecret}
                customerId={setupData.customerId}
            />
        </Elements>
    </div>
</>
);
};

export default StripeSubscription;
